module.exports = __webpack_public_path__ + "a8a10a3e/img/send-icon.3cfb6275.svg";